module.exports = __webpack_public_path__ + "img/mygame.c4f99c32.png";